import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.css';

const DefListColumn = ({
  title,
  data,
  className,
  dataTestHandle,
  edit,
}) => (
  <dl className={classNames(styles.list, className)}>
    <dt>{title}</dt>
    <dd data-test-handle={dataTestHandle}>{data}{edit && edit}</dd>
  </dl>
);

DefListColumn.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array, PropTypes.node]),
  className: PropTypes.string,
  dataTestHandle: PropTypes.string,
  edit: PropTypes.object,
};

DefListColumn.defaultProps = {
  title: '',
  data: '',
  className: '',
  dataTestHandle: '',
  edit: null,
};

export default DefListColumn;



// WEBPACK FOOTER //
// ./src/components/DefListColumn/index.js